var _rect, _rect2, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeetings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.45,
    y: 2,
    width: 2,
    height: 4.32
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.97,
    y: 2,
    width: 2,
    height: 4.32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17,4.32H16v2h1A1.88,1.88,0,0,1,18.84,8.2v9.93A1.88,1.88,0,0,1,17,20H7a1.88,1.88,0,0,1-1.88-1.87V8.2A1.88,1.88,0,0,1,7,6.32h.4v-2H7A3.88,3.88,0,0,0,3.16,8.2v9.93A3.88,3.88,0,0,0,7,22H17a3.88,3.88,0,0,0,3.88-3.87V8.2A3.88,3.88,0,0,0,17,4.32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49,11.6a1.25,1.25,0,0,0,0-2.5h0a1.25,1.25,0,1,0,0,2.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.24,10.35A1.25,1.25,0,1,0,14.49,9.1h0A1.25,1.25,0,0,0,13.24,10.35Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.49,14.1h0a1.25,1.25,0,1,0,1.25,1.25A1.25,1.25,0,0,0,14.49,14.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49,16.6a1.25,1.25,0,0,0,0-2.5h0a1.25,1.25,0,1,0,0,2.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetings);
export default __webpack_public_path__ + "static/media/meetings.7f80d824de68ce156c00aba3f76fbd84.svg";
export { ForwardRef as ReactComponent };